import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

import CartLocation from '../components/CartLocation'
import {
  isLoadingAddressSelector,
  selectedShippingAddressFakeFirstSelector,
} from '@/checkout-instore-legacy/shipping/selectors'
import { simulationAddressSelector } from '@/checkout-instore-legacy/cart/simulation/selectors'
import { countryCodeSelector } from '@/checkout-instore-legacy/order/selectors'

export const mapStateToPropsSelector = createStructuredSelector({
  isLoadingAddress: isLoadingAddressSelector,
  cartAddress: selectedShippingAddressFakeFirstSelector,
  simulationAddress: simulationAddressSelector,
  countryCode: countryCodeSelector,
})

export default connect(mapStateToPropsSelector)(withRouter(CartLocation))
